import React from 'react';
import { Sparkles, Shield, Users, Award, Smartphone, Heart } from 'lucide-react';

const services = [
  { title: 'Reducción de Grasa Localizada', desc: 'Elimina los depósitos rebeldes en abdomen, cintura y brazos con tecnología certificada.', img: 'https://customer-assets.emergentagent.com/job_body-sculpt-zone/artifacts/4s75hjmm_2da01ec2-2e63-422f-9dbe-307a1bb392d2.jpg' },
  { title: 'Tonificación Muscular y Firmeza', desc: '20.000 contracciones por sesión. Define, esculpe y fortalece sin esfuerzo físico.' },
  { title: 'Remodelación y Contorno', desc: 'Esculpe tu silueta con protocolos personalizados según tu morfología corporal.' },
  { title: 'Mejora de la Piel y Celulitis', desc: 'Estimula colágeno, reduce piel de naranja y devuelve la luminosidad natural.' },
];

const serviceIcons = [
  // waist / abdomen icon
  <svg key="0" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round">
    <path d="M8 4c0 4 -2 6 -2 8s2 4 2 8" />
    <path d="M16 4c0 4 2 6 2 8s-2 4 -2 8" />
    <ellipse cx="12" cy="12" rx="3" ry="1.5" />
  </svg>,
  // muscle / arm
  <svg key="1" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round">
    <path d="M4 16c0-2 2-4 6-4s5-3 5-6" />
    <path d="M15 6c2 0 4 2 4 4s-2 4-4 4-2-2-2-4 0-4 2-4z" />
    <circle cx="8" cy="18" r="2" />
  </svg>,
  // body / contour
  <svg key="2" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round">
    <path d="M5 12h2M17 12h2" />
    <path d="M9 4c-1 3 -1 5 -1 8s 0 5 1 8M15 4c1 3 1 5 1 8s 0 5 -1 8" />
    <ellipse cx="12" cy="12" rx="2.5" ry="1.2" />
  </svg>,
  // skin / drop
  <svg key="3" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3s6 7 6 12a6 6 0 0 1 -12 0c0 -5 6 -12 6 -12z" />
    <path d="M9 14c0 1.5 1.3 3 3 3" />
  </svg>,
];

export default function Hero({ onStart }) {
  return (
    <section className="hero-bg stars min-h-screen relative" data-testid="hero-section">
      {/* top brand */}
      <header className="relative z-20 px-4 sm:px-8 lg:px-16 pt-6 sm:pt-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_body-sculpt-zone/artifacts/p3cj44va_Logo%20mistika.png"
            alt="Mistika"
            className="h-20 sm:h-24 lg:h-28 w-auto"
            style={{ filter: 'drop-shadow(0 0 24px rgba(34, 211, 238, 0.5)) drop-shadow(0 0 14px rgba(236, 72, 153, 0.35))' }}
            data-testid="brand-logo"
          />
        </div>
        <div className="hidden sm:flex items-center gap-2 chip-dark">
          <Shield className="w-3.5 h-3.5" />
          Centro especializado y seguro
        </div>
      </header>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-10 sm:py-14 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        {/* Left: copy + image */}
        <div className="float-in">
          <span className="pill-tag mb-6">
            <Sparkles className="w-3 h-3" />
            DESCUBRE EN 60 SEGUNDOS
          </span>
          <h1 className="font-display font-bold leading-[1.05] mb-6">
            <span className="block text-white text-3xl sm:text-4xl lg:text-5xl mb-3">
              Descubre en{' '}
              <span className="italic bg-gradient-to-br from-fuchsia-200 via-fuchsia-300 to-purple-400 bg-clip-text text-transparent">60 segundos</span>
            </span>
            <span className="block text-purple-100/90 text-xl sm:text-2xl lg:text-3xl font-medium leading-tight">
              qué está bloqueando tu
            </span>
            <span className="block italic bg-gradient-to-br from-fuchsia-200 via-fuchsia-300 to-purple-400 bg-clip-text text-transparent text-3xl sm:text-4xl lg:text-5xl mt-1">
              pérdida de grasa corporal
            </span>
          </h1>

          <div className="flex items-center gap-3 mb-3 mt-8">
            <span className="h-px flex-1 bg-gradient-to-r from-transparent via-fuchsia-400/60 to-transparent max-w-[60px]"></span>
            <span className="px-3 py-1.5 rounded-full bg-fuchsia-500/20 border border-fuchsia-400/50 text-fuchsia-200 text-sm sm:text-base font-bold tracking-[0.18em] uppercase shadow-lg shadow-fuchsia-500/30 neon-pulse">
              ⚡ Bloqueo identificado
            </span>
            <span className="h-px flex-1 bg-gradient-to-l from-transparent via-fuchsia-400/60 to-transparent max-w-[60px]"></span>
          </div>
          <p className="text-purple-100/85 leading-relaxed max-w-md text-base sm:text-lg mb-7">
            Tu protocolo exacto está a{' '}
            <span className="font-display italic font-bold text-white text-xl sm:text-2xl">5 preguntas.</span>
          </p>

          {/* Image with neon ring */}
          <div className="relative w-full max-w-sm aspect-square mx-auto lg:mx-0 mb-6" data-testid="hero-image-container">
            <div className="neon-ring"></div>
            <div className="neon-ring-2"></div>
            <div className="absolute inset-[8%] rounded-full overflow-hidden">
              <video
                src="https://69f12f021c78705e2c4a6757.imgix.net/Video%20Web.mp4"
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover"
                style={{ filter: 'brightness(0.95) contrast(1.05) saturate(1)' }}
                data-testid="hero-video"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-950/60 via-transparent to-fuchsia-900/20 pointer-events-none"></div>
            </div>
            {/* floating stat */}
            <div className="absolute -bottom-3 -right-2 glass-card-sm px-4 py-3 backdrop-blur" data-testid="floating-stat">
              <p className="font-display text-2xl font-bold text-white leading-none">15.000<span className="text-fuchsia-400">+</span></p>
              <p className="text-[10px] tracking-widest text-purple-300/70 uppercase mt-1">Pacientes felices</p>
            </div>
          </div>
        </div>

        {/* Right: services card */}
        <div className="glass-card relative z-10 p-6 sm:p-9 float-in" data-testid="services-card" style={{ animationDelay: '.15s' }}>
          <p className="pill-tag mb-5">
            <Sparkles className="w-3 h-3" />
            NUESTROS SERVICIOS
          </p>
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-white mb-1">
            Tecnología <span className="text-fuchsia-300">100% segura</span>
          </h2>
          <p className="text-purple-200/85 text-sm sm:text-base mb-7">
            Tratamientos{' '}
            <span className="font-bold tracking-wider px-2 py-0.5 rounded-md bg-gradient-to-r from-fuchsia-500/30 to-purple-500/30 border border-fuchsia-400/50 text-white shadow-lg shadow-fuchsia-500/30 neon-pulse">
              NO QUIRÚRGICOS
            </span>
          </p>

          <div className="space-y-3 sm:space-y-3.5 mb-7">
            {services.map((s, i) => (
              <div key={i} className="service-pill flex items-center gap-4 px-4 sm:px-5 py-3.5 sm:py-4" data-testid={`service-item-${i}`}>
                <div className="w-7 h-7 rounded-full bg-gradient-to-br from-fuchsia-400 to-purple-600 flex items-center justify-center text-white shadow-lg shadow-fuchsia-500/40 flex-shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white font-semibold text-sm sm:text-base leading-tight">{s.title}</p>
                  <p className="text-purple-200/65 text-xs sm:text-[13px] mt-1 leading-snug hidden sm:block">{s.desc}</p>
                </div>
                <div className="service-icon">{serviceIcons[i]}</div>
              </div>
            ))}
          </div>

          <button
            onClick={onStart}
            className="cta-glow cta-attention w-full text-base sm:text-lg flex items-center justify-center gap-2 relative"
            data-testid="hero-cta-button"
          >
            <span className="cta-shine"></span>
            <span className="relative z-10">Iniciar cuestionario</span>
            <span className="text-xl relative z-10 cta-arrow">→</span>
          </button>
          <p className="text-center text-purple-200/55 text-xs mt-3.5">
            100% gratuita · Sin compromiso · Confidencial
          </p>
        </div>
      </div>

      {/* Bottom stats */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-8 lg:px-16 pb-12">
        <div className="glass-card-sm grid grid-cols-2 sm:grid-cols-4 gap-4 p-5 sm:p-6" data-testid="stats-bar">
          {[
            { Icon: Users, n: '15.000+', l: 'Pacientes felices' },
            { Icon: Award, n: '10+ Años', l: 'De experiencia' },
            { Icon: Smartphone, n: '8+', l: 'Tecnologías certificadas' },
            { Icon: Heart, n: '4.9 ★', l: 'Resultados comprobados' },
          ].map(({ Icon, n, l }, i) => (
            <div key={i} className="text-center sm:text-left flex flex-col sm:flex-row items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-purple-500/15 border border-purple-400/30 flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5 text-fuchsia-300" />
              </div>
              <div>
                <p className="font-display text-lg font-bold text-white leading-tight">{n}</p>
                <p className="text-[11px] sm:text-xs text-purple-300/70 leading-tight">{l}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
